export enum Category {
  CUSTOMER = "customer",
  SHIFTS = "shifts",
  PATIENT = "patient",
  PRESENTATION = "presentation",
  DIAGNOSIS = "diagnosis",
  ORGANS = "organs",
  ANAMNESIS = "anamnesis",
  PHYSICAL_EXAM = "physical-exam",
  LABORATORY_EXAMS = "laboratory-exams",
  IMAGING_DIAGNOSTICS = "imaging-diagnostics",
  DIET = "diet",
  ALLERGIES = "allergies",
  INSURANCE_NUMBERS = "insuranceNumbers",
  REFERRING_PHYSICIANS = "referringPhysicians",
  COLORS_DOG = "colors-dog",
  MARKETING = "marketing",
  ACTIVE_SUBSTANCE = "active-substance",
  PROFIT_CENTER = "profit-center",
  STUDIES = "studies",
  WARD = "ward",
  SPECIALIZATION = "specialization"
}

export interface Tag {
  id: string;
  name: string;
  category?: string;
  color?: string;
  createdAt: string;
  deleted?: boolean;
}

export type TagCreate = Omit<Tag, "id" | "number" | "createdAt">;

export type TagUpdate = Omit<Tag, "id" | "number" | "createdAt">;

export type TagLight = Pick<
  Tag,
  "id" | "name" | "category" | "color" | "deleted"
>;
